import { Component, inject, OnInit } from '@angular/core';
import { ImportLinesheetComponent } from 'gung-standard';
import { HlDisplayPortalFeaturesService, OpenOrdersSettingsGroup } from '../../services/hl-display-portal-features.service';
import { HlDisplayOrderImportService } from '../../services/hl-display-order-import.service';
import { first, map } from 'rxjs';
import { saveAs } from 'file-saver';
import { GungNotificationService } from 'gung-common';

@Component({
  selector: 'hl-display-import-linesheet',
  templateUrl: './hl-display-import-linesheet.component.html',
  styleUrl: './hl-display-import-linesheet.component.scss',
  standalone: false
})
export class HLDisplayImportLinesheetComponent extends ImportLinesheetComponent implements OnInit {

  public allowImportForUsers = false;
  private featureSettingsService = inject(HlDisplayPortalFeaturesService);
  private hlOrderImportService = inject(HlDisplayOrderImportService);
  private notificationService = inject(GungNotificationService);

  ngOnInit(): void {
    this.featureSettingsService.getPortalFeatureGroup("openOrdersSettingsGroup")
      .pipe(first(), map(settings => settings as OpenOrdersSettingsGroup)).subscribe(settingsGroup => {
        this.allowImportForUsers = settingsGroup.allowImportForUsers;
      });
    super.ngOnInit();
  }

  public clearResults() {
    console.log('clearResults');
    this.multiOrderResult = undefined;
    this.result = undefined;
  }

  public downloadMultiOrderTemplate() {
    this.hlOrderImportService
      .downloadMultiOrderTemplate()
      .pipe(first())
      .subscribe({
        next: blob => saveAs(blob, 'HLDisplay-OrderImport-MultiOrderColumnFormat.xlsx'),
        error: err => {
          console.error('Failed to download multi-order template', err);
          this.notificationService.notify('ERROR', 'AN_ERROR_HAS_OCCURED', 'error');
        }
      });
  }
}
